import { createStore } from './utilities';

export const { history, store, persistor } = createStore();
